export default __webpack_public_path__ + "static/media/facebook.55c5bdc7.svg";